import { ReactNode } from 'react';

import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';

import ErrorPage from '~/pages/error/ErrorPage';
import { isDefined } from '~/utils/predicates';

import { AppRoute, ROUTES } from './routes';

const renderRoute = (route: AppRoute): ReactNode => {
  const commonProps = {
    key: route.path,
    path: route.path,
    errorElement: <ErrorPage />,
  };

  if (isDefined(route.index)) {
    return (
      <Route index={route.index} element={route.element} {...commonProps} loader={route.loader} />
    );
  }

  if (route.element) {
    return (
      <Route {...commonProps} element={route.element} loader={route.loader}>
        {(route.children ?? []).map(renderRoute)}
      </Route>
    );
  }

  return null;
};

export const router = createBrowserRouter(createRoutesFromElements(ROUTES.map(renderRoute)), {
  basename: '/en/chamonix/karaoke-catalog',
});
